import { render, staticRenderFns } from "./UserInfoList.vue?vue&type=template&id=6073a5ff&scoped=true&"
import script from "./UserInfoList.vue?vue&type=script&lang=js&"
export * from "./UserInfoList.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoList.vue?vue&type=style&index=0&id=6073a5ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073a5ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
